import React from 'react';
import { StyledHorizontalSpacer } from './styles';
import { IHorizontalSpacer } from './types';

const HorizontalSpacer: React.FunctionComponent<IHorizontalSpacer> = ({ margin = '' }) =>
    <StyledHorizontalSpacer margin={margin}/>;

export default HorizontalSpacer;
